<template>
<div class="widthFull center pt-1 pb-3">
  <loading v-if="loadingState" />
  <div class="container">
    <div class="row justify-content-center pb-3">

      <div class="col-md-12">



        <div class="row justify-content-center pb-3">
          <div class="col-6" :class="{'underlineBox': cartVisibile}">
            <p class="pointer small  Bold" v-on:click="showCart()"> <img class="img-fluid widthFull payImage mb-2" src="../../assets/images/cardPP.png"> </p>

          </div>
          <div class="col-6" :class="{'underlineBox': ppButtonVisibile}">
            <p class="pointer small Bold" v-on:click="showPaypal()"> <img class="img-fluid widthFull payImage mb-2 mt-2" src="../../assets/images/paypal1.png"> </p>
          </div>
        </div>

        <div class="col-md-12">

          <div class="radio ">


            <div class="pp-container center" id="pp-container" v-if="ppButtonVisibile">

              <div id="paypal-button-container"></div> <!-- il div che viene sostituito con il bottone -->
              <p class="small2 mt-4">
                <b>SOFORT</b> un sistema di pagamento Europeo per eseguire <b>Bonifici Diretti</b>
                utilizzando le proprie credenziali bancarie online per trasferire denaro dal proprio conto bancario nella massima sicurezza.
              </p>
            </div>




          </div>

          <div class="radio ">



            <div class="form-container" id="form-container" v-if="cartVisibile">

              <div id="payments-sdk__contingency-lightbox"></div>
              <form id="my-form" class="center" >
                <div class="card-holder-name">

                  <label class="cardinfo-label text-left Bold" for="card-holder-label">Titolare Carta</label>
                  <input type="text" id="card-holder-name" class="input-wrapper widthFull p-4" name="card-holder-name" autocomplete="off" placeholder="" />
                </div>
                <div class="cardinfo-card-number">
                  <label class="cardinfo-label text-left Bold" for="card-number">Numero Carta</label>
                  <div class='input-wrapper ' id="card-number"></div>
                  <div id="card-image" :class="cardClass"></div>
                </div>
                <div class="cardinfo-wrapper">
                  <div class="cardinfo-exp-date">
                    <label class="cardinfo-label text-left Bold" for="expiration-date">Scadenza</label>
                    <div class='input-wrapper ' id="expiration-date"></div>
                  </div>
                  <div class="cardinfo-cvv">
                    <label class="cardinfo-label text-left Bold" for="cvv">CVV</label>
                    <div class='input-wrapper ' id="cvv"></div>
                  </div>
                </div>
                <input v-show="showCardPayButton" id="button-pay" type="button" class="show-button" value="Paga" />
              </form>
            </div>
          </div>


        </div>

      </div>

    </div>
  </div>
</div>
</template>

<script>
import {
  AUTH_REQUEST,
  AUTH_SOCIAL
} from 'actions/auth'
import {
  mapGetters,
  mapState
} from 'vuex'
import axios from 'axios'

import Vue from 'vue'

const moment = require('moment')

export default {
  name: 'paypal_nt',
  components: {
    //StripeCheckout
  },
  props: {
    practice: String,
    userToken: String,
    locale: String,
    currency: String,
    items: Array,
    invoiceNumber: String,
    amount: String,
    PaypalOn: Boolean,
    flow: String,
    sepaOn: Boolean,
    dl: String,

  },
  data() {
    return {
      client_token: '',
      token: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      error: '',
      loadingState: false,
      loading: false,
      moment: require('moment'),
      show_card: false,
      //STRIPE
      pk: process.env.STRIPE_PUBLISHABLE_KEY,
      front_url: process.env.FRONT_END_URL,
      iva: process.env.IVA,
      buyPlan: {
        price: process.env.PRACTIC_PRICE,
        iva: process.env.PRACTIC_PRICE * 0.22,
        amount: (process.env.PRACTIC_PRICE + process.env.PRACTIC_PRICE * 0.22),
        amount_enea: parseFloat(process.env.PRACTIC_PRICE + (process.env.PRACTIC_PRICE * 0.22) + 50 * 1.22).toFixed(2),
        amount_dcast: parseFloat(process.env.PRACTIC_PRICE + (process.env.PRACTIC_PRICE * 0.22) + 10 * 1.22).toFixed(2),
        amount_enea_dcast: parseFloat(process.env.PRACTIC_PRICE + (process.env.PRACTIC_PRICE * 0.22) + 50 * 1.22 + 10 * 1.22).toFixed(2),
        priceEnea: 50,
        ivaEnea: 11,
        priceDcast: 10,
        ivaDcast: 2.2
      },
      credentials: {
        sandbox: process.env.PAYPAL_ID,
        production: process.env.PAYPAL_ID
        // SECRET ENSsI2hX79egH1CKfDNPQnf0SskbcGt0r9GRiVDwNMArGz2HAMP6c3-960hpQka2gXob5GzcDbAUNlfY
      },
      cartVisibile: false,
      ppButtonVisibile: false,
      loadingState: false,
      orderId: false,
      orderData: {},
      showCardPayButton: false,
      cardClass: ''
    }

  },
  methods: {
    showPaypal() {
      console.warn(' showPaypal ', !this.ppButtonVisibile)
      if (this.cartVisibile) {
        this.cartVisibile = false
      }
      this.ppButtonVisibile = !this.ppButtonVisibile
      this.create_paypal_client_token()
    },
    showCart() {
      console.warn(' showCart ', !this.cartVisibile)
      if (this.ppButtonVisibile) {
        this.ppButtonVisibile = false
      }
      this.cartVisibile = !this.cartVisibile
      this.create_paypal_client_token()
    },
    create_order: async function(source) {
      var items = []
      var _vue = this

      _vue.orderId = false

      for (var x in _vue.items) {
        var item = {}
        item.name = _vue.items[x].name
        item.description = _vue.items[x].description
        var pr = _vue.items[x].price

        var unit_ammount = {
          currency_code: _vue.currency,
          value: parseFloat(pr).toFixed(2)

        }

        //item.tax = tax
        item.unit_amount = unit_ammount
        item.quantity = _vue.items[x].quantity
        item.category = 'DIGITAL_GOODS'

        items.push(item)

      }

      var item_total = {
        currency_code: _vue.currency,
        value: parseFloat(_vue.amount).toFixed(2)
      }
      var breakdown = {
        item_total: item_total
      }

      var order = {
        intent: "CAPTURE",
        purchase_units: [{
          reference_id: _vue.invoiceNumber,
          description: _vue.invoiceNumber,
          invoice_id: _vue.invoiceNumber,
          custom_id: _vue.practice,
          soft_descriptor: _vue.getProfile.partita_iva,
          amount: {
            currency_code: _vue.currency,
            value: parseFloat(_vue.amount).toFixed(2),
            breakdown: breakdown
          },
          items: items
        }],
        application_context:{
            "shipping_preference":"NO_SHIPPING"
        }
      }

      var dataX = {
        practice: _vue.practice,
        pratica: _vue.practice,
        userToken: _vue.userToken,
        locale: _vue.locale,
        //currency: this.currency,
        items: _vue.items,
        invoiceNumber: _vue.invoiceNumber,
        //amount: this.amount,
        PaypalOn: _vue.PaypalOn,
        flow: _vue.flow,
        sepaOn: _vue.sepaOn,
        dl: _vue.dl,
        client_token: _vue.client_token,
        env: process.env.PAYPAL_ENV == 'SANDBOX' ? '.sandbox' : '',
        key: process.env.PAYPAL_ENV == 'SANDBOX' ? _vue.credentials.sandbox : _vue.credentials.production,
        order: order
      }

      return axios({
          url: process.env.ROOT_API + 'api/create_paypal_order',
          method: 'POST',
          data: dataX,
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          _vue.loadingState = false

          if (resp.data.token.id) {
            _vue.orderId = resp.data.token.id
            return resp.data.token.id
          } else {
            _vue.showAlert()
            return false
          }

          //return data.id;

        })
        .catch(resp => {

          _vue.loadingState = false
          _vue.showAlert()
          return false

        })
    },
    capture_order: async function(orderID, source) {
      console.log("ORDER:", orderID);

      var _vue = this
      _vue.loadingState = true
      _vue.orderData = {}
      var xd = await axios({
          url: process.env.ROOT_API + 'api/capture_paypal_order',
          method: 'POST',
          data: {
            order_id: orderID,
            card: source == 'cart' ? true : false,
            pratica: _vue.practice,
            env: process.env.PAYPAL_ENV == 'SANDBOX' ? '.sandbox' : '',
            key: process.env.PAYPAL_ENV == 'SANDBOX' ? _vue.credentials.sandbox : _vue.credentials.production
          },
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          _vue.loadingState = false

          if ( resp.data.token ){
          var errorDetail = Array.isArray(resp.data.token.details) && resp.data.token.details[0];

          if (errorDetail && errorDetail.issue === 'DUPLICATE_INVOICE_ID') {
            _vue.showAlert()
            return false
          } else if (resp.data.token.id) {
            // ALL OK
            console.warn(' CAPTURE ORDER FUNCTION => OK', resp.data.token)
            if (resp.data.token.status) {
              if (resp.data.token.status == 'COMPLETED' || resp.data.token.status == 'APPROVED') {
                var res = resp.data.token
                res.cart = source == 'cart' ? 'YES' : 'NO'

                if (!res.payer) {
                  if (res.payment_source) {

                    if (res.payment_source.card) {
                      var payer = {
                        name: {
                          given_name: res.payment_source.card.brand,
                          surname: res.payment_source.card.type,
                        },
                        email_address: res.payment_source.card.last_digits,
                        payer_id: "CARD_PAYMENT",
                        address: {
                          country_code: "IT"
                        }
                      }
                    } else {
                      var payer = {
                        name: {
                          given_name: 'UNDEFINED',
                          surname: 'UNDEFINED',
                        },
                        email_address: 'UNDEFINED',
                        payer_id: "UNDEFINED_PAYMENT",
                        address: {
                          country_code: "IT"
                        }
                      }
                    }

                    res.payer = payer

                  }

                }

                res.payer.payment_method = source == 'cart' ? 'PAYPAL_CART' : 'PAYPAL_FORM'
                _vue.$emit('paymentPPSuccess', res)
              }
            }

            _vue.orderData = resp.data.token
            return resp.data.token
          } else {
            _vue.loadingState = false
            return false
            _vue.showAlert()
          }
          _vue.loadingState = false
        }else{
          _vue.loadingState = false
          return false
          _vue.showAlert()
        }
          //return data.id;

        })
        .catch(resp => {
          console.error(' CAPTURE ORDER CATCH => ', resp)
          return false
          _vue.loadingState = false
          _vue.showAlert()

        })

      return xd

    },
    paypal_render_buttons() {
      var _vue = this
      //let orderId;

      // PP BUTTONS
      if (_vue.ppButtonVisibile) {
        // BUTTON HANDLER
        paypal.Buttons({
          createOrder: function(data, actions) {
            _vue.loadingState = true

            return _vue.create_order('button')

          },
          onApprove: function(data, actions) {

            return _vue.capture_order(data.orderID, 'button')

          }
        }).render('#paypal-button-container');
      } else {

        // PP CARD
        // If this returns false or the card fields aren't visible, see Step #1.
        if (paypal.HostedFields.isEligible()) {
          // Renders card fields
          paypal.HostedFields.render({
            // Call your server to set up the transaction
            createOrder: function() {
              return _vue.create_order('card')
            },
            styles: {
              '.valid': {
                'color': 'green'
              },
              '.invalid': {
                'color': 'red'
              }
            },
            fields: {
              number: {
                selector: "#card-number",
                placeholder: "4111 1111 1111 1111"
              },
              cvv: {
                selector: "#cvv",
                placeholder: "123"
              },
              expirationDate: {
                selector: "#expiration-date",
                placeholder: "MM/YY"
              }
            }
          }).then(function(cardFields) {


            cardFields.on('validityChange', function (event) {
                    //console.log('CCF Event "validityChange", state='+cardFields.getState() + ",event=" + event);
                        // Check if all fields are valid, then show submit button
                    var formValid = Object.keys(event.fields).every(function (key) {
                        return event.fields[key].isValid;
                    });

                    if (formValid) {
                      _vue.showCardPayButton = true
                    } else {
                      _vue.showCardPayButton = false
                    }
            });

            cardFields.on('cardTypeChange', function (event) {
              console.log('CCF Event "cardTypeChange", state='+cardFields.getState() + ",event=" + event);
              console.log( event);

              // Change card bg depending on card type
              if (event.cards.length === 1) {
                  _vue.cardClass = event.cards[0].type
              }

            });

            document.querySelector("#button-pay").addEventListener('click', (event) => {
              event.preventDefault();
              _vue.loadingState = true
              console.warn(' CLICK CARD PAY BUTTON ', cardFields)
              cardFields.submit({
                // Cardholder's first and last name
                // Trigger 3D Secure authentication
                contingencies: ['3D_SECURE'],
                cardholderName: document.getElementById('card-holder-name').value,
                // Billing Address
                /*billingAddress: {
                  // Street address, line 1
                  streetAddress: document.getElementById('card-billing-address-street').value,
                  // Street address, line 2 (Ex: Unit, Apartment, etc.)
                  extendedAddress: document.getElementById('card-billing-address-unit').value,
                  // State
                  region: document.getElementById('card-billing-address-state').value,
                  // City
                  locality: document.getElementById('card-billing-address-city').value,
                  // Postal Code
                  postalCode: document.getElementById('card-billing-address-zip').value,
                  // Country Code
                  countryCodeAlpha2: document.getElementById('card-billing-address-country').value
                }*/
              }).then(async () => {

                var orderData = await _vue.capture_order(_vue.orderId, 'cart')

                if (orderData) {
                  //var orderData =  _vue.orderData
                  _vue.loadingState = true
                  console.warn(' orderData => ', orderData)
                  // Three cases to handle:
                  //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                  //   (2) Other non-recoverable errors -> Show a failure message
                  //   (3) Successful transaction -> Show confirmation or thank you

                  // This example reads a v2/checkout/orders capture response, propagated from the server
                  // You could use a different API or structure for your 'orderData'
                  var errorDetail = Array.isArray(orderData.details) && orderData.details[0];

                  if (errorDetail && errorDetail.issue === 'INSTRUMENT_DECLINED') {
                    return actions.restart(); // Recoverable state, per:
                    // https://developer.paypal.com/docs/checkout/integration-features/funding-failure/
                  }

                  if (errorDetail) {
                    var msg = 'Sorry, your transaction could not be processed.';
                    if (errorDetail.description) msg += '\n\n' + errorDetail.description;
                    if (orderData.debug_id) msg += ' (' + orderData.debug_id + ')';
                    _vue.showAlert(msg)
                    return alert(msg); // Show a failure message
                  }

                  // Show a success message or redirect
                  console.warn('Transaction completed!');

                  /*fetch('/your-server/api/order/' + orderId + '/capture/', {
                    method: 'post'
                  }).then(function(res) {
                    return res.json();
                  }).then(function(orderData) {

                  })*/
                }else{
                  _vue.loadingState = false
                  _vue.showAlert()
                }

              }).catch(function(err) {
                _vue.loadingState = false
                _vue.showAlert()
                console.warn('Payment could not be captured! ' + JSON.stringify(err))
              });


            });

          });
        } else {
          // Hides card fields if the merchant isn't eligible
          //document.querySelector("#card-form").style = 'display: none';
        }
      }



    },
    create_paypal_client_token() {
      this.loadingState = true
      // Create an instance of the Stripe object with your publishable API key

      if (process.env.PAYPAL_ENV == 'SANDBOX') {
        var data = {
          key: this.credentials.sandbox,
          env: '.sandbox'
        }
      } else {
        var data = {
          key: this.credentials.production,
          env: ''
        }
      }


      axios({
          url: process.env.ROOT_API + 'api/create_paypal_client_token',
          method: 'POST',
          data: data,
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {

          if (resp.data.token) {
            this.client_token = resp.data.token
            this.loadPayPalScript(resp.data.token)
          }

        })
        .catch(resp => {

          this.loadingState = false


        })

    },
    loadPayPalScript(val) {
      this.$loadScript(
          "https://www.paypal.com/sdk/js?components=hosted-fields,buttons,funding-eligibility&client-id=" + process.env.PAYPAL_ID + '&currency=EUR&disable-funding=mybank&enable-funding=sofort', {
            'data-client-token': val
          }
        ).then(() => {
          //this.loadButtons = false
          console.warn(' PAYPAL OK ')
          this.loadingState = false
          this.paypal_render_buttons()
        })
        .catch(() => {
          // Failed to fetch script
          this.loadingState = false
          console.error(' PAYPAL ERROR AUTH ')
        });
    },
    showAlert(text = false) {
      // Use sweetalret2

      if (text) {
        var msg = text
      } else {
        var msg = 'Ci dispiace! Riprova piu tardi'
      }

      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: msg,
      });
    },

  },
  watch: {

  },
  created() {



    if (process.env.PAYPAL_ENV == 'SANDBOX') {
      this.envPP = 'sandbox'
    }



  },

  mounted() {

    this.showPaypal()

  },
  computed: {
    ...mapGetters(['getProfile', 'loginerror', 'isAuthenticated', 'isProfileLoaded', 'authStatus']),
    ...mapState({
      //response: state => `${state.status.response.data}`,
    }),

  },
}
</script>

<style lang="css" scoped>
  iframe{
    min-height: 10px!important;
  }
  #card-form{
    text-align: left;
  }
  .cardFormLabel{
    text-align: left;
  }

  @media (max-width: 476px) {
    .form-container {
      border: none;
    }
  }

  .cardinfo-wrapper {
    display: flex;
    justify-content: space-around;
  }


  .card-shape, #my-sample-form.visa, #my-sample-form.master-card, #my-sample-form.maestro, #my-sample-form.american-express, #my-sample-form.discover, #my-sample-form.unionpay, #my-sample-form.jcb, #my-sample-form.diners-club {
    border-radius: 6px;
    padding: 2em 2em 1em;
  }
  @media (max-width: 476px) {

    .card-shape, #my-sample-form.visa, #my-sample-form.master-card, #my-sample-form.maestro, #my-sample-form.american-express, #my-sample-form.discover, #my-sample-form.unionpay, #my-sample-form.jcb, #my-sample-form.diners-club {
      padding: 2em 1.5em 1em;
    }
  }


  #pp-container {
    background-color: #FFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    padding: 10px;
    width: 100%;
    margin-bottom: 1em;
    transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);
    -webkit-animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
            animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
    z-index: 1;
  }




  #my-sample-form {
    background-color: #FFF;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    padding: 10px;
    width: 100%;
    margin-bottom: 2em;
    transition: all 600ms cubic-bezier(0.2, 1.3, 0.7, 1);
    -webkit-animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
            animation: cardIntro 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
    z-index: 1;
  }
  #my-sample-form:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.06);
  }
  @media (max-width: 476px) {
    #my-sample-form {
      box-sizing: border-box;
      padding: 7em 2em 2em;
      width: 100%;
    }
  }
  #my-sample-form.visa {
    color: #fff;
    background-color: #0D4AA2;
  }
  #my-sample-form.master-card {
    color: #fff;
    background-color: #363636;
    background: linear-gradient(115deg, #d82332, #d82332 50%, #f1ad3d 50%, #f1ad3d);
  }
  #my-sample-form.maestro {
    color: #fff;
    background-color: #363636;
    background: linear-gradient(115deg, #009ddd, #009ddd 50%, #ed1c2e 50%, #ed1c2e);
  }
  #my-sample-form.american-express {
    color: #fff;
    background-color: #007CC3;
  }
  #my-sample-form.discover {
    color: #fff;
    background-color: #ff6000;
    background: linear-gradient(#d14310, #f7961e);
  }
  #my-sample-form.unionpay, #my-sample-form.jcb, #my-sample-form.diners-club {
    color: #fff;
    background-color: #363636;
  }

  .cardinfo-label {
    display: block;
    font-size: 11px;
    margin-bottom: 0.5em;
    text-transform: uppercase;
  }

  .cardinfo-exp-date {
    margin-right: 1em;
    width: 100%;
  }

  .cardinfo-cvv {
    width: 100%;
  }

  #button-pay {
    cursor: pointer;
    width: 100%;
    font-size: 15px;
    border: 0;
    padding: 1.2em 1em;
    color: #fff;
    background: #282c37;
    border-radius: 4px;
    z-index: 0;
    -webkit-transform: translateY(-100px);
            transform: translateY(-100px);
    transition: all 500ms cubic-bezier(0.2, 1.3, 0.7, 1);
    opacity: 0;
    -webkit-appearance: none;
  }
  #button-pay:hover {
    background: #535b72;
  }
  #button-pay:active {
    -webkit-animation: cardIntro 200ms cubic-bezier(0.2, 1.3, 0.7, 1);
            animation: cardIntro 200ms cubic-bezier(0.2, 1.3, 0.7, 1);
  }
  #button-pay.show-button {
    -webkit-transform: translateY(0);
            transform: translateY(0);
    opacity: 1;
  }

  .cardinfo-card-number {
    position: relative;
  }
  .cardholder {
    position: relative;
  }
  #card-image {
    position: absolute;
    top: 1em;
    right: 0.5em;
    width: 44px;
    height: 28px;
    background-image: url(	);
    background-size: 86px 458px;
    border-radius: 4px;
    background-position: -100px 0;
    background-repeat: no-repeat;
    margin-bottom: 1em;
    background-size: contain;
  }

  #card-image.visa {
    background: url(../../assets/images/visa.png);
    background-size: contain;
  }
  #card-image.master-card {
    background: url(../../assets/images/mastercard.png);
    background-size: contain;
  }
  #card-image.american-express {
    background: url(../../assets/images/americanexpress.png);
    background-size: contain;
  }
  #card-image.discover {
    background-position: 0 -163px;
  }
  #card-image.maestro {
    background: url(../../assets/images/maestro.png);
    background-size: contain;
  }
  #card-image.jcb {
    background-position: 0 -221px;
  }
  #card-image.diners-club {
    background-position: 0 -133px;
  }

  /*--------------------
  Inputs
  --------------------*/
  .input-wrapper {
    border-radius: 2px;
    background: rgba(255, 255, 255, 0.86);
    height: 1.75em;
    border: 1px solid #eee;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.06);
    padding: 5px 10px;
    margin-bottom: 1em;
  }

  .card-holder-name,
  .cardinfo-card-number,
  .cardinfo-exp-date,
  .cardinfo-cvv {
    transition: -webkit-transform 0.3s;
    transition: transform 0.3s;
    transition: transform 0.3s, -webkit-transform 0.3s;
  }



  #form-container
  {

  }

  #pp-container
  {

  }

</style>



// WEBPACK FOOTER //
// src/components/loadDocuments/paypal_nt.vue